import React from 'react'
import { useTranslation } from 'react-i18next'
import PermissionWrapper from '@/components/UI/PermissionWrapper/PermissionWrapper'

interface ActionButtonsProps {
  editMode: boolean
  buttonText: string
  onSave: () => void
  onCancel: () => void
  onCreate: () => void
  className?: string
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  editMode,
  buttonText,
  onSave,
  onCancel,
  onCreate,
  className = '',
}) => {
  const { t } = useTranslation('translation')

  return (
    <div className={`d-flex align-items-center flex-wrap ${className}`}>
      {editMode && (
        <PermissionWrapper>
          <button className="btn btn-primary mr-3" onClick={onSave}>
            {t('Save')}
          </button>
        </PermissionWrapper>
      )}
      {!editMode && (
        <PermissionWrapper>
          <button className="btn btn-primary third-step" onClick={onCreate}>
            {editMode ? t('Save') : buttonText}
          </button>
        </PermissionWrapper>
      )}
      {editMode && (
        <button className="btn btn-outline-primary ml-3" onClick={onCancel}>
          {t('Cancel')}
        </button>
      )}
    </div>
  )
}

export default ActionButtons
